import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import Button from '../../Utils/Button';
import FormRadioGroup from '../../Utils/Form/FormRadioGroup';
import FormSelect from '../../Utils/Form/FormSelect';
import './style.scss';
import {Checkbox, FormControlLabel} from "@mui/material";
import {useTranslation} from "react-i18next";
import {ORGANIZATION_TYPE} from "../../../Constants.js";

// TODO (Alex): This needs to be refactored completely, cleaned up, broken down into subcomponents and use useForm!

const generateButton = (id, scratchItemIndex, onChange) => {
    return <Button
        id='delete-role'
        iconName='close'
        className='button__icon color--alfa-foreground'
        typpe={'button'}
        onClick={(e) => {
            e.target.id = id;
            e.target.type = 'button'
            e.preventDefault();
            onChange(e, scratchItemIndex);
        }}
    />
}

const generateFormSelect = (id, scratchItemIndex, scratchItem, organizations, disabledSelectValues, onChange) => {
    
    return <FormSelect
        id={id?.toString()}
        value={scratchItem.organization_id?.toString()}
        blankOptionName={'--Select an organization--'}
        key={`organization-select-${scratchItemIndex}`}
        options={organizations}
        optionsNameKey='name'
        optionsValueKey='id'
        disabledValues={disabledSelectValues}
        onChange={(e) => {
            onChange(e, scratchItemIndex);
        }}
    />
}

const generateFormRadioGroup = (id, scratchItemIndex, scratchItem, rolesSansSuperAdmin, onChange, currentOrg) => {
    const isTypeProvider = currentOrg.name.includes(ORGANIZATION_TYPE.PROVIDER);
    const formattedRoles = rolesSansSuperAdmin.map(role => {
        return {
            ...role,
            name: isTypeProvider && role.name === 'ADMIN' ? 'Provider Admin' : role.name,
        };
    });
    return <FormRadioGroup
        wrapClass='role__wrap--radio-group'
        radioWrapClass='role__wrap--radio'
        radioClass=''
        radioOptions={formattedRoles}
        checkedItem={scratchItem?.role_id?.toString()}
        onChange={(e) => {
            e.target.id = id;
            onChange(e, scratchItemIndex);
        }}
    />
}

const generateCheckbox = (id, parentOrganizationId, currentOrg, onChange) => {
    const currentOrgId = currentOrg?.id
    return <Checkbox
        id={id?.toString()}
        disabled={!!parentOrganizationId && parentOrganizationId !== currentOrgId}
        checked={parentOrganizationId?.toString() === currentOrgId?.toString()}
        name={'parentOrganizationId'}
        value={currentOrgId}
        onChange={(e) => onChange(e, currentOrgId)}
    />
}

const generateFieldSet = (parentOrganizationId, scratchItem, scratchItemIndex, organizations, rolesSansSuperAdmin, disabledSelectValues, id, onChange, handleChangeParent, t) => {

      const currentOrg = organizations.find((item) => scratchItem.organization_id === item.id);
    return (
        <fieldset className='role__wrap' key={`roles-wrap-${scratchItemIndex}`}>
            <div className='role__selection-wrap'>
                {generateButton(id, scratchItemIndex, onChange)}
                {generateFormSelect(id, scratchItemIndex, scratchItem, organizations, disabledSelectValues, onChange)}
            </div>
            {scratchItem.organization_id && generateFormRadioGroup(id, scratchItemIndex, scratchItem, rolesSansSuperAdmin, onChange, currentOrg)}
            <FormControlLabel
                label={t('parent_org')}
                control={generateCheckbox(id, parentOrganizationId, currentOrg, onChange)}
            />
        </fieldset>
    );
};


const RoleSettings = ({
                          id,
                          onChange,
                          organizations,
                          scratchOrgRoles,
                          rolesSansSuperAdmin,
                          disabledSelectValues,
                          handleChangeParent,
                          parentOrganizationId,
                      }) => {
    const { t } = useTranslation()
    return (
        <div className='role__wrap--group'>
          {scratchOrgRoles?.reduce((accumulator, scratchItem, scratchItemIndex) => {
                if (organizations.find((org) => org.id === scratchItem.organization_id) || !Object.entries(scratchItem).length) {
                    accumulator.push(generateFieldSet(parentOrganizationId, scratchItem, scratchItemIndex, organizations, rolesSansSuperAdmin, disabledSelectValues, id, onChange, handleChangeParent, t));
                }
                return accumulator;
            }, [])}
        </div>
    );
};

export default RoleSettings;

RoleSettings.propTypes = {
    id: PropTypes.string,
    organizations: PropTypes.array,
    scratchOrgRoles: PropTypes.array,
    setScratchOrgRoles: PropTypes.func,
    rolesSansSuperAdmin: PropTypes.array,
    disabledSelectOptions: PropTypes.array,
    orgRolesToDelete: PropTypes.array,
    setOrgRolesToDelete: PropTypes.func
};
